import type { Environment } from '../environment.types';

import { resolveReplacedConfiguration } from './resolveReplacedConfiguration';

// This constant will be replaced after build when the Docker container is
// started. This allows us to deploy the same image to both staging and
// production environments.
export const fallbackConfiguration = 'production';

const isProd =
  resolveReplacedConfiguration(fallbackConfiguration) === 'production';

export const environment: Environment = {
  configuration: resolveReplacedConfiguration(fallbackConfiguration),
  nativeShareBaseUrl: isProd
    ? 'https://app.work4all.com'
    : 'https://staging.work4all.de',
  devtools: {
    graphQLExplorer: false,
  },
  entities: {
    task: true,
    note: true,
    appointment: true,
    callMemo: true,
    eMail: true,
    letter: true,
    document: true,
    ticket: true,
    customer: true,
    supplier: true,
    contact: true,
    project: true,
    'file-settings': true,
    eMailTemplate: true,
    textBuildingBlock: true,
    eMailSignature: true,
    timeTracking: true,
    salesOpportunities: true,
    deliveryNote: true,
    article: true,
    ra: true,
    raViewModel: true,
    travelReceipts: true,
    addressConnection: true,
    inboundInvoice: true,
    offer: true,
    invoice: true,
    order: true,
    contract: true,
    calculation: true,
    demand: true,
    inboundDeliveryNote: true,
    reViewModel: true,
    checkList: true,
    user: true,
    fullUser: true,
    wordDocumentTemplate: true,
    wordLetterTemplate: true,
    webShopDefinition: true,
    ledgerAccount: true,
    tenant: true,
    billProjectHoursResult: true,
    fileServiceProviderConfig: true,
    travelExpenses: true,
    numberingLogic: true,
    tenantBankAccount: true,
    costCenter: true,
    country: true,
    serviceContract: true,
    lookUp: true,
    ticketCategory1: true,
    topic: true,
    ticketKind: true,
  },
};
